<p>temperature-template works!</p>
